
import { concat, replace, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { map as map_1, reduce, length, empty, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { ConfirmationDialog } from "../../Components/Dialog.js";
import { TableMsg$1 } from "./Types.js";
import { DropdownButton } from "../../Components/Button.js";
import Cog from "../../../public/assets/icons/Cog.svg";
import { empty as empty_1, toArray, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { FSharpMap__get_Item } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { toLocalTime, toString } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";

function downloadCsv(csvContent, filename, onDownloaded) {
    const csv = join("\r\n", map((row) => join(";", map((cell) => {
        const escaped = replace(cell, "\"", "\"\"");
        if ((((escaped.indexOf(";") >= 0) ? true : (escaped.indexOf("\"") >= 0)) ? true : (escaped.indexOf("\r") >= 0)) ? true : (escaped.indexOf("\n") >= 0)) {
            return ("\"" + escaped) + "\"";
        }
        else {
            return escaped;
        }
    }, row)), csvContent));
    const options = {
        endings: "transparent",
        type: "text/csv;charset=utf-8;",
    };
    const blob = new Blob(["﻿", csv], options);
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    onDownloaded();
}

export function TableElementsCounter(props) {
    let elems, arg_1;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-center", "h-10", "px-3.5", "text-sm", "rounded-lg", "bg-primary", "text-white"])], (elems = [reactElement("div", {
        children: (arg_1 = {
            number: props.NumberOfElements,
        }, patternInput[1].t("table.number_of_elements", arg_1)),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function TableSettings(props) {
    let Title, Icon;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setResetTableConfigurationDialogIsOpen = patternInput_1[1];
    if ((props.CSVDownloadActivated ? true : props.ResetFilterEnabled) ? true : props.ResetConfigurationEnabled) {
        const xs = [createElement(ConfirmationDialog, (Title = t("table.confirm_reset_title"), {
            Description: t("table.confirm_reset_description"),
            IsOpen: patternInput_1[0],
            OnClose: () => {
                setResetTableConfigurationDialogIsOpen(false);
            },
            OnConfirm: () => {
                props.Dispatch(new TableMsg$1(14, []));
                setResetTableConfigurationDialogIsOpen(false);
            },
            Title: Title,
        })), createElement(DropdownButton, (Icon = Cog(), {
            Classes: empty(),
            ComponentState: props.CSVDownloadRunning ? "disabled" : "enabled",
            DisplayArrow: false,
            DisplayDivider: false,
            Elements: toList(delay(() => append(props.CSVDownloadActivated ? singleton({
                DisplayName: t("table.download_csv"),
                OnClick: () => {
                    props.Dispatch(new TableMsg$1(3, [true]));
                    downloadCsv(toArray(delay(() => {
                        let array;
                        return append(singleton(map((column_1) => FSharpMap__get_Item(props.ColumnDefinitionMap, column_1.id).Header, (array = props.Table.getAllLeafColumns(), array.filter((column) => column.getIsVisible())))), delay(() => map((row) => map((cell) => {
                            const matchValue = FSharpMap__get_Item(props.ColumnDefinitionMap, cell.column.id).AccessorFunction(row.original);
                            switch (matchValue.tag) {
                                case 3:
                                    if (length(matchValue.fields[0]) === 0) {
                                        return "";
                                    }
                                    else {
                                        return reduce((labels_1, label_1) => concat(labels_1, ", ", ...label_1), map_1((label) => label.Name, matchValue.fields[0]));
                                    }
                                case 1:
                                    return "";
                                case 2:
                                    return matchValue.fields[0];
                                case 4:
                                    return "";
                                case 5:
                                    return "";
                                case 6:
                                    if (matchValue.fields[0] == null) {
                                        return "";
                                    }
                                    else {
                                        const date = matchValue.fields[0];
                                        return toString(toLocalTime(date), "dd.MM.yyyy");
                                    }
                                case 7:
                                    return toString(toLocalTime(matchValue.fields[0]), "dd.MM.yyyy HH:mm");
                                default:
                                    return matchValue.fields[0];
                            }
                        }, row.getVisibleCells()), props.Table.getRowModel().rows)));
                    })), "export.csv", () => {
                        props.Dispatch(new TableMsg$1(3, [false]));
                    });
                },
            }) : empty_1(), delay(() => append(props.ResetFilterEnabled ? singleton({
                DisplayName: t("table.reset_filter"),
                OnClick: () => {
                    props.Dispatch(new TableMsg$1(10, []));
                },
            }) : empty_1(), delay(() => (props.ResetConfigurationEnabled ? singleton({
                DisplayName: t("table.reset_configuration"),
                OnClick: () => {
                    setResetTableConfigurationDialogIsOpen(true);
                },
            }) : empty_1()))))))),
            Icon: unwrap(Icon),
            TestId: "download-csv-button",
        }))];
        return react.createElement(react.Fragment, {}, ...xs);
    }
    else {
        return defaultOf();
    }
}

